import PropTypes from 'prop-types';

export const categoryShape = PropTypes.shape({
  name: PropTypes.string,
  id: PropTypes.string,
});
